<template>
    <div class="regist">
        <div class="login-header">
            <div class="login-brand">
                <img :src="logoImg" class="logo"/>
            </div>
        </div>
        <div class="resigt_cent">
            <h1 class="role">注册账号</h1>

            <div class="resigt_from">
                <el-form :rules="dataRule" ref="form" status-icon :model="dataForm">
                    <el-form-item prop="mobile" label="">
                        <el-input v-model="dataForm.mobile" placeholder="输入常用手机号码" autocomplete="off"></el-input>
                        <!-- <el-input style="position: fixed;bottom: -9999px;"></el-input> -->
                    </el-form-item>
                    <!-- <div >

                    </div> -->
					<el-form-item prop="code" label="">
						<el-input class="codeInput" style="width: 247px;margin-right: 15px;" placeholder="请输入验证码" v-model="dataForm.code"></el-input>
						<el-button type="info" style="width: 128px;height: 70px;line-height: 70px;border-radius: 14px;padding: 0;" @click="sendCode" v-show="isShow">发送验证码</el-button>
						<el-button type="info" :disabled="false" v-show="!isShow" style="padding: 0;width: 128px;height: 70px;line-height: 70px;border-radius: 14px;background-color: lightgrey">{{secondsCount}}秒后重发</el-button>
					</el-form-item>
                    <el-form-item prop="password" label="">
                        <!-- <el-input type="password" style="position: fixed;bottom: -9999px;"></el-input> -->
                        <el-input type="password" v-model="dataForm.password" placeholder="输入您的密码"
                                  autocomplete="new-password"></el-input>
                    </el-form-item>

                    <el-form-item prop="optionCheck" label-width="30px">
                        <el-checkbox-group v-model="dataForm.optionCheck" style="display: inline-block;">
                            <el-checkbox label="协议" style="margin:0 0 20px 0" name="type">我已阅读并同意</el-checkbox>
                        </el-checkbox-group>
                        <span @click="dialogVisible = true" style="color: #2C4BD5;cursor: pointer;">《用户注册及使用隐私协议》</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="dataFormSubmit('form')" class="regBtn" style="width: 400px;height: 80px;line-height: 80px;border-radius: 40px!important;font-size: 20px;">
                            注册
                        </el-button>
                        <!-- <router-link to="/login" style="margin-left:20px;"><i class="el-icon-arrow-left"></i>已有账号，点击登录</router-link> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="login-footer">
            <p>Copyright 2010-2019 财天下科技有限公司 版权所有 <a href="https://beian.miit.gov.cn" style="color: #939393" >京ICP备20006561号-1</a></p>
        </div>
		<el-dialog :show-close="false" top="6vh" width="1056px" title="用户注册及使用隐私协议" :visible="dialogVisible">
			<div style="font-size: 12px;color: #333;line-height: 34px;text-indent: 24px;text-align: left;height: 640px;overflow-y: scroll;">
				<p>在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户注册及使用隐私协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议约定财天下共享经济服务平台（以下简称“财天下”平台）与用户之间关于灵活用工服务的权利义务。“用户”是指注册、登录、使用“财天下”平台服务的个人。本协议可由“财天下”平台随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本平台中查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用“财天下”平台提供的服务，用户继续使用服务将被视为接受修改后的协议。 </p>
				<p>
					<br /><span style="display: inline-block;width: 24px;"></span>一、账号注册
					<br /><span style="display: inline-block;width: 48px;"></span>1、用户在使用本 “财天下”平台服务前需要注册一个“财天下”账号。“财天下”账号应当使用手机号码绑定注册，请用户使用尚未与“财天下”平台账号绑定的手机号码，以及未被“财天下”平台根据本协议封禁的手机号码注册账号。“财天下”平台服务可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。
					<br /><span style="display: inline-block;width: 48px;"></span>2、“财天下”系基于财天下共享经济服务平台服务产品，用户注册时应当授权“财天下”平台使用其个人信息方可成功注册账号。故用户完成注册即表明用户同意“财天下”平台提取、公开及使用用户的信息。
					<br /><span style="display: inline-block;width: 48px;"></span>3、鉴于“财天下”账号的绑定注册方式，您同意“财天下”平台在注册时将允许您的手机号码及手机设备识别码等信息用于注册。
					<br /><span style="display: inline-block;width: 48px;"></span>4、在用户注册及使用本平台服务时，“财天下”平台需要搜集能识别用户身份的个人信息，以便平台在提供灵活用工服务时可以在必要时联系用户，或为用户提供更好的使用体验。“财天下”平台搜集的信息包括但不限于用户的姓名、地址，并同意对这些信息的使用将受限于第二条用户个人隐私信息保护的约束。
					<br /><span style="display: inline-block;width: 24px;"></span>二、用户个人隐私信息保护
					<br /><span style="display: inline-block;width: 48px;"></span>1、如果“财天下”平台发现或收到他人举报或投诉用户违反本协议约定的，平台有权不经通知随时对相关内容，包括但不限于用户资料、发贴记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁 、设备封禁 、功能封禁的处罚，并通知用户处理结果。
					<br /><span style="display: inline-block;width: 48px;"></span>2、因违反用户协议被封禁的用户，可以自行与“财天下”平台联系。其中，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可提交申诉，“财天下”平台将对申诉进行审查，并自行合理判断决定是否变更处罚措施。
					<br /><span style="display: inline-block;width: 48px;"></span>3、用户理解并同意，“财天下”平台有权依据合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
					<br /><span style="display: inline-block;width: 48px;"></span>4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿“财天下”平台与合作公司、关联公司，并使之免受损害。
					<br /><span style="display: inline-block;width: 24px;"></span>三、用户发布内容规范
					<br /><span style="display: inline-block;width: 48px;"></span>1、本条所述内容是指用户使用服务的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本平台服务所产生的内容。
					<br /><span style="display: inline-block;width: 48px;"></span>2、用户不得利用“财天下”账号或平台服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：
					<br /><span style="display: inline-block;width: 48px;"></span>(1) 反对宪法所确定的基本原则的；
					<br /><span style="display: inline-block;width: 48px;"></span>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
					<br /><span style="display: inline-block;width: 48px;"></span>(3) 损害国家荣誉和利益的；
					<br /><span style="display: inline-block;width: 48px;"></span>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；
					<br /><span style="display: inline-block;width: 48px;"></span>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
					<br /><span style="display: inline-block;width: 48px;"></span>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
					<br /><span style="display: inline-block;width: 48px;"></span>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
					<br /><span style="display: inline-block;width: 48px;"></span>(8) 侮辱或者诽谤他人，侵害他人合法权益的；
					<br /><span style="display: inline-block;width: 48px;"></span>(9) 含有法律、行政法规禁止的其他内容的信息。
					<br /><span style="display: inline-block;width: 48px;"></span>3、用户不得利用“财天下”账号或平台服务制作、上载、复制、发布、传播如下干扰“服务”正常运营，以及侵犯其他用户或第三方合法权益的内容：
					<br /><span style="display: inline-block;width: 48px;"></span>(1) 含有任何性或性暗示的；
					<br /><span style="display: inline-block;width: 48px;"></span>(2) 含有辱骂、恐吓、威胁内容的；
					<br /><span style="display: inline-block;width: 48px;"></span>(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
					<br /><span style="display: inline-block;width: 48px;"></span>(4) 涉及他人隐私、个人信息或资料的；
					<br /><span style="display: inline-block;width: 48px;"></span>(5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
					<br /><span style="display: inline-block;width: 48px;"></span>(6) 含有其他干扰本平台服务正常运营和侵犯其他用户或第三方合法权益内容的信息。

					<br /><span style="display: inline-block;width: 24px;"></span>四、使用规则
					<br /><span style="display: inline-block;width: 48px;"></span>1、用户在本平台服务中或通过平台服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表“财天下”平台的观点、立场或政策，“财天下”平台对此不承担任何责任。
					<br /><span style="display: inline-block;width: 48px;"></span>2、用户不得利用“财天下”平台账号或平台服务进行如下行为：
					<br /><span style="display: inline-block;width: 48px;"></span>(1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
					<br /><span style="display: inline-block;width: 48px;"></span>(2) 强制、诱导其他用户关注、点击链接页面或分享信息的；
					<br /><span style="display: inline-block;width: 48px;"></span>(3) 虚构事实、隐瞒真相以误导、欺骗他人的；
					<br /><span style="display: inline-block;width: 48px;"></span>(4) 利用技术手段批量建立虚假账号的；
					<br /><span style="display: inline-block;width: 48px;"></span>(5) 利用“财天下”账号或平台服务从事任何违法犯罪活动的；
					<br /><span style="display: inline-block;width: 48px;"></span>(6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
					<br /><span style="display: inline-block;width: 48px;"></span>(7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰“财天下”平台正常运营或服务未明示授权的行为。
					<br /><span style="display: inline-block;width: 48px;"></span>3、用户须对利用“财天下”账号或平台服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与“财天下”平台无关。如因此给“财天下”平台或第三方造成损害的，用户应当依法予以赔偿。
					<br /><span style="display: inline-block;width: 48px;"></span>4、“财天下”平台提供的服务中可能包括广告，用户同意在使用过程中显示“财天下”和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对该广告信息进行的交易负责， 对用户因该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，“财天下”平台不承担任何责任。
					<br /><span style="display: inline-block;width: 24px;"></span>五、其他
					<br /><span style="display: inline-block;width: 48px;"></span>1、“财天下”平台郑重提醒用户注意本协议中免除“财天下”责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。
					<br /><span style="display: inline-block;width: 48px;"></span>2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和“财天下”平台之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，双方一致同意提交至被告所在地有管辖权的人民法院诉讼解决。
					<br /><span style="display: inline-block;width: 48px;"></span>3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。

					<br /><span style="display: inline-block;width: 24px;"></span>本《协议》版权由“财天下”平台所有，并保留一切对本《协议》解释的权利。

						</p>
			</div>
			<div slot="footer" class="dialog-footer">
			  <el-button style="color: #409eff;" type="text" @click="dataForm.optionCheck=[];dialogVisible = false">不同意</el-button>
			  <el-button style="background-color: #409eff;border: none;" type="primary" @click="doRead">我同意</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { isMobile,testPassword } from '@/utils/validate'
import aesJs from '../../utils/login-aes'

export default {
  data () {
    return {
      userPhone: '',
      secondsCount: 0, // 倒计秒数初始化定义
      isShow: true, // 是否显示发送验证码按钮
      logoImg: require('../../assets/img/logo.png'), // icon
      dataForm: {
        mobile: '',
        code: '',
        password: '',
        optionCheck: []
      },
      dialogVisible: false
    }
  },

  computed: {
    dataRule () {
      var validatePass2 = (rule, value, callback) => {
        if (this.dataForm.password !== value) {
          return callback(new Error(this.$t('user.validate.confirmPassword')))
        }
        callback()
      }
      var validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.mobile') })))
        }
        callback()
      }
      var checkpassword = (rule, value, callback) => {
        if(testPassword(value)){
          callback()
        }else{
          callback(new Error('请输入密码'))
        }
        // if (/^[A-Za-z0-9]{8,15}$/.test(value)) {
        //   callback()
        // } else {
        //   callback(new Error('请输入密码'))
        // }
      }
      return {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { message: '请设置8到12位数字，大写、小写字母，符号，至少三种',validator: checkpassword,trigger: 'blur'}
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '输入正确的电话号码', validator: validateMobile, trigger: 'blur' }
        ],
        optionCheck: [
          { type: 'array', required: true, message: '请勾选我已详细阅读并同意', trigger: 'change' }
        ]

      }
    }
  },
  created () {
    console.log(this.$route.query.userType == '1')
    // this.dataForm.userType = this.$route.
  },

  methods: {
    closeDialog () {
      this.dataForm.type = true
      this.dialogVisible = false
    },
    sendCode () {
      if (this.dataForm.mobile == '') {
        return this.$message.error('手机号不能为空')
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!reg.test(this.dataForm.mobile)) {
        return this.$message.error('请输入正确的手机号')
      } else {
        // 发送短信验证
        this.$http.post('/sys/register/send-code', { mobile: this.dataForm.mobile }, {
          headers: {
            'content-type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          // 倒计时
          if (res.data.code == 0) {
            let that = this
            console.log(that)
            that.secondsCount = 60
            // 切换倒计时按钮
            that.isShow = false
            // 倒计时函数
            let timer = setInterval(function () {
							    that.secondsCount--
							    if (that.secondsCount <= 0) {
							        clearInterval(timer)
							        that.isShow = true
							    }
            }, 1000)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    // 表单提交
    dataFormSubmit: debounce(function (dataForm) {
      this.$refs[dataForm].validate((valid) => {
        if (!valid) {
          return false
        }
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        paramsForm.password = aesJs.encrypt(paramsForm.password)
        this.$http.post('/sys/register/submit3',
            paramsForm,
          { headers: {
            'content-type': 'application/json;charset=UTF-8'
          } }).then(({ data: res }) => {
            // this.dataForm.password = aesJs.decrypt(this.dataForm.password)
          if (res.code === 10002) {
            return this.$message.error('此手机号已存在!')
          }
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if (res.msg === 'success') {
            this.$message({
              message: '注册成功',
              type: 'success',
              duration: 1000
            })
            this.$router.replace({ name: 'login' })
          }
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    doRead () {
      this.dataForm.optionCheck[0] ? this.dataForm.optionCheck[0] = '协议' : this.dataForm.optionCheck.push('协议')
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang='scss'>
    .regist {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        background: #F3F4F5;
        overflow-y: auto;
    }

    .regist .login-header {
        width: 100%;
        height: 100px;
        background: #fff;
        position: relative;
    }

    .regist .login-header .login-brand {
        width: 1200px;
        position: absolute;
        left: 50%;
        margin-left: -600px;
    }

    .logo {
        width: 200px;
        margin-top: 26px;
    }

    .login-footer {
        width: 460px;
		margin-left: 710px;
        padding: 20px;
        color: #666666;
		font-size: 12px;
        p {
            height: 16px;
            margin: 10px 0;
            text-align: center;
        }
    }

    .role {
        line-height: 86px;
		margin: 0;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
		text-align: center;
		border-bottom: 2px solid #d9d9da;
    }

    .resigt_cent {
        width: 1200px;
        margin: 30px auto 10px;
        background: #fff;
        overflow: hidden;
        clear: both;
    }

    .resigt_from {
        display: flex;
        justify-content: center;
        padding: 90px 40px;
        box-sizing: border-box;
    }

    .resigt_from .el-form-item {
        flex: 1;
    }

    .regBtn {
        background: linear-gradient(90deg, rgba(87, 156, 255, 1) 0%, rgba(51, 114, 242, 1) 100%);
        box-shadow: 0px 6px 9px 0px rgba(26, 57, 179, 0.32);
        border-radius: 40px;
    }
</style>
<style>
	.resigt_from input{
		width: 390px;
		height: 70px;
		border: none;
		border-radius: 14px;
		background-color: #f8f8f8;
		line-height: 70px;
	}
	.codeInput input{
		width: 247px;
	}
	.resigt_from .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #409eff;
	}
</style>
